export const newOrderExportColumns = {
  sr: {
    name: "SR",
    value: "SR",
    apiKey: "sr",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 150,
    order: 1,
  },
  isshipped: {
    name: "已出貨",
    value: "isShipped",
    apiKey: "isshipped",
    uiType: "check",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 100,
    order: 2,
  },
  isreceived: {
    name: "已收到",
    value: "isReceived",
    apiKey: "isreceived",
    uiType: "check",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 80,
    order: 3,
  },
  order_platform: {
    name: "平台",
    value: "order_platform",
    apiKey: "order_platform",
    uiType: "select",
    options: "platform",
    optionType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 150,
    order: 4,
  },
  order_id: {
    name: "訂單號(Order ID)",
    value: "order_id",
    apiKey: "order_id",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 180,
    order: 5,
  },
  date: {
    name: "日期(Date)",
    value: "date",
    apiKey: "date",
    uiType: "date",
    dateFormatUI: "yy/mm/dd",
    dateFormatLabel: "YYYY-MM-DD",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 100,
    order: 6,
  },
  amazon_sku: {
    name: "Amazon SKU",
    value: "amazon_SKU",
    apiKey: "amazon_sku",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 200,
    order: 7,
  },
  model: {
    name: "外箱印刷型號(Model)",
    value: "model",
    apiKey: "model",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 200,
    order: 8,
  },
  qty: {
    name: "數量(Qty)",
    value: "qty",
    apiKey: "qty",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 100,
    order: 9,
  },
  daily_inventoryList: {
    name: "Pallet Number",
    value: "PalletNos",
    apiKey: "daily_inventoryList",
    uiType: "pallet",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: true,
    width: 330,
    order: 10,
  },
  warehouse: {
    name: "warehouse",
    value: "warehouse",
    apiKey: "warehouse",
    uiType: "select",
    options: "warehouse",
    optionType: "number",
    isShow: true,
    checked: true,
    listDisabled: true,
    listUI: true,
    required: false,
    width: 120,
    order: 11,
  },
  wayfair_sku: {
    name: "Wayfair SKU",
    value: "wayfair_SKU",
    apiKey: "wayfair_sku",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 230,
    order: 12,
  },
  customer_name: {
    name: "客人名稱(Customer Name)",
    value: "customer_name",
    apiKey: "customer_name",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 210,
    order: 13,
  },
  amount: {
    name: "產品總價(Amount)",
    value: "amount",
    apiKey: "amount",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 150,
    order: 14,
  },
  total: {
    name: "總金額(total)",
    value: "total",
    apiKey: "total",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 120,
    order: 15,
  },
  promote: {
    name: "折扣(Promo)",
    value: "promo",
    apiKey: "promote",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 120,
    order: 16,
  },
  refund: {
    name: "退款金額(Refund)",
    value: "refund",
    apiKey: "refund",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 200,
    order: 17,
  },
  note: {
    name: "備註(Notes)",
    value: "note",
    apiKey: "note",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 200,
    order: 18,
  },
  length: {
    name: "L",
    value: "length",
    apiKey: "length",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 80,
    order: 19,
  },
  width: {
    name: "W",
    value: "width",
    apiKey: "width",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 80,
    order: 20,
  },
  high: {
    name: "H",
    value: "high",
    apiKey: "high",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 80,
    order: 21,
  },
  weight: {
    name: "重量",
    value: "weight",
    apiKey: "weight",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 80,
    order: 22,
  },
  girth: {
    name: "Girth",
    value: "girth",
    apiKey: "girth",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 80,
    order: 23,
  },
  carrier: {
    name: "貨運商(Carrier)",
    value: "carrier",
    apiKey: "carrier",
    uiType: "select",
    options: "carriers",
    optionType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 140,
    order: 24,
  },
  tracking: {
    name: "追蹤碼(Tracking)",
    value: "tracking",
    apiKey: "tracking",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 200,
    order: 25,
  },
  tracking_link: {
    name: "連結",
    value: "tracking_link",
    apiKey: "tracking_link",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 200,
    order: 26,
  },
  isinsurance: {
    name: "保險",
    value: "isInsurance",
    apiKey: "isinsurance",
    uiType: "check",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 70,
    order: 27,
  },
  issign: {
    name: "簽名",
    value: "isSign",
    apiKey: "issign",
    uiType: "check",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 70,
    order: 28,
  },
  delivery_fee: {
    name: "運費",
    value: "delivery_fee",
    apiKey: "delivery_fee",
    uiType: "number",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 100,
    order: 29,
  },
  claim_id: {
    name: "求償ID(Claim ID)",
    value: "claim_id",
    apiKey: "claim_id",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 200,
    order: 30,
  },
  claim_result: {
    name: "求償結果",
    value: "claim_result",
    apiKey: "claim_result",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 200,
    order: 31,
  },
  mos_id: {
    name: "OMS ID",
    value: "mos_id",
    apiKey: "mos_id",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: true,
    required: false,
    width: 200,
    order: 32,
  },
  fnsku: {
    name: "fnsku",
    value: "fnsku",
    apiKey: "fnsku",
    uiType: "string",
    isShow: true,
    checked: true,
    listDisabled: false,
    listUI: false,
    required: false,
    width: 150,
    order: 33,
  },
};
